import React, {Component} from 'react';
import {decorate, observable, action, isObservableObject, toJS} from 'mobx';
import { observer, inject } from 'mobx-react';
import { ColorRing } from  'react-loader-spinner'
import { createFFmpeg, fetchFile } from "@ffmpeg/ffmpeg";
import Papa from 'papaparse';
import XLSX from 'xlsx/dist/xlsx.full.min.js';

import _ from "underscore";
import { srcToWebP } from 'webp-converter-browser'
import './style.scss'

import PageTitle from "../../../components/common/PageTitle";
import ModalLoading from "../../../components/common/ModalLoading";

import { toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';

import FeatherIcon from 'feather-icons-react';
import {
  Form,
  FormGroup,
  FormTextarea,
  FormCheckbox,
  FormSelect,
  Tooltip,
  Modal,
  ModalBody,
  ModalHeader,
  InputGroup,
  InputGroupAddon,
  FormInput,
  ButtonGroup,
  Button,
  Collapse,
  Col, Row, Card, CardHeader, CardBody
} from "shards-react";
import moment from "moment";
import {reactLocalStorage as Storage} from "reactjs-localstorage";

@inject(({ common }) => ({ getUploadUrl: common.getUploadUrl, base64UploadImages: common.base64UploadImages, cafe24UploadFiles: common.cafe24UploadFiles, uploadImg: common.uploadImg, removeMedia: common.removeMedia, getDoc: common.getDoc }))
@inject(({ teamUser }) => ({ isLogin: teamUser.isLogin, me:teamUser.me }))
@inject(({ product }) => ({ getProductList: product.getProductList, setProductSync: product.setProductSync, updateProductReplay: product.updateProductReplay }))
@inject(({ review }) => ({ updateReview:review.updateReview, uploadReviewExImgs:review.uploadReviewExImgs, updateMassReview:review.updateMassReview, getAnalysisList:review.getAnalysisList, genAIReviewAnalysis:review.genAIReviewAnalysis }))
@inject(({ AOA }) => ({ adminCusData:AOA.adminCusData }))

@observer
class ReviewMassWrite extends Component {

  //basic
  @observable store = {};
  @observable teamUser = {};
  @observable permissions = {}
  @observable company = {};
  @observable isLogin = false;
  @observable isLoading = true;
  @observable urlParams = new URLSearchParams(window.location.search);

  //list
  @observable filePlatform = "my"; //"my";
  @observable listParams = {
    page:1, limit:100000,
  }
  @observable searchParams = {
    keyword: '',
    overReviewCount: '',
  };
  @observable list = [];
  @observable errData = [];
  @observable goodList = [];
  @observable exImgList = {};

  //modals
  @observable modals = {
    data: null,
    isWriteForm: false,
    widgetData: {},
    isMakeWidgetModal: false
  };

  @observable widgetUrl;
  @observable categories = [];
  @observable newReview = {};
  @observable isShowCollapse = false;
  @observable isUploading = false;
  @observable isUseImgCopy = false;

  constructor(props) {
    super(props);
    this.init()
  }


  @action
  init = async (key) => {
    if(this.props.isLogin) {
      let _this = this;
      this.reviewSize = 1001;
      //basic
      this.isLogin = this.props.isLogin;
      this.teamUser = this.props.me;
      this.store = this.props.me.store ? this.props.me.store : {};
      this.permissions = this.props.me.permissions;

      this.isUse = false;
      if(this.teamUser.isPaidShop) {
        this.isUse = true;
      }

      if(this.store.presidentName !== "윤정진") {
        let isConfirm = window.confirm("해당 리뷰작성에 대한 책임은 작성자 또는 작성자가 속한 회사에 책임이 있습니다.")
        if(!isConfirm) {
          window.history.back();
        }
      }


      this.listParams.store_id = this.teamUser.selStore_id;
      this.listParams.shopNo = this.teamUser.selShopNo ? this.teamUser.selShopNo : 1;
      //this.listParams.teamUserId = this.teamUser.id;

      //url params
      for (const key of this.urlParams.keys()) {
        if(['page'].indexOf(key) > -1 || ['limit'].indexOf(key) > -1) {
          this.listParams[key] = parseInt(this.urlParams.get(key));
        }
        else {
          this.searchParams[key] = this.urlParams.get(key);
        }
      }

      this.getProductList();
    }

  };


  getProductList = async() => {
    if(this.listParams.store_id) {



      let storageKey = 'goodList_' + this.store.platformId + "_" + moment().format('YYYY-MM');
      let tempGoodList = await Storage.getObject(storageKey);
      //let tempGoodList = {};
      if(!tempGoodList.totalDocs || tempGoodList.totalDocs === 0) {
        for (let i = 0; i < localStorage.length; i++) {
          if(localStorage.key(i).indexOf("goodList_" + this.store.platformId) > -1 ) {
            localStorage.removeItem(localStorage.key(i));
          }
        }
        this.listParams.searchParams = this.searchParams;
        tempGoodList = await this.props.getProductList(this.listParams);
        Storage.setObject(storageKey, tempGoodList);
      }


      this.goodList = _.indexBy(tempGoodList.docs, 'platformProductId');
      console.log(this.goodList)

      this.isLoading = false;
    }
    else {
      //console.log('null store_id');
    }
  };


  handleFileUpload = async (event) => {
    let _this = this;
    this.isLoading = true;
    const file = event.target.files[0];
    if (file) {
      const fileExtension = file.name.split('.').pop().toLowerCase();

      if (fileExtension === 'csv') {
        Papa.parse(file, {
          header: true,
          skipEmptyLines: true,
          complete: (result) => {
            console.log(result.data)
            _this.toMyData(result.data);
          },
          error: (error) => {
            console.error('CSV 파싱 오류:', error);
          },
        });
      } else if (fileExtension === 'xlsx' || fileExtension === 'xls') {
        const reader = new FileReader();
        reader.onload = (e) => {
          const data = e.target.result;
          const workbook = XLSX.read(data, { type: 'array' });
          const firstSheetName = workbook.SheetNames[0];
          const worksheet = workbook.Sheets[firstSheetName];
          let jsonData = XLSX.utils.sheet_to_json(worksheet);

          // writerAt 필드에 날짜 숫자값이 있을 경우 -> yyyy-mm-dd 형식으로 변환
          jsonData = jsonData.map(row => {
            // writerAt 변환 처리
            if (row.writerAt && typeof row.writerAt === 'number') {
              const dateObj = XLSX.SSF.parse_date_code(row.writerAt);
              row.writerAt = `${dateObj.y}-${String(dateObj.m).padStart(2, '0')}-${String(dateObj.d).padStart(2, '0')}`;
            }
            return row;
          });
          
          _this.toMyData(jsonData)
        };
        reader.readAsArrayBuffer(file);
      }
    }
  };

  recombinationData = async (targetModel, otherModel, arrayData, addData) => {
    let _this = this;

    let reData = [];
    let platform = addData.platform ? addData.platform : (addData.fromWrite ? addData.fromWrite : '');
    for(let i in arrayData) {
      let row = arrayData[i];

      if(!row.parent_article_no) {
        let product_id, userOrder_id;
        let newRow = {
          exReview_id: row.review_id,
          shopNo: row.shop_no,
          platform:platform,
          syncFrom:platform,
          fromWrite: addData.fromWrite ? addData.fromWrite : platform,
        };


        for(let j in targetModel) {
          let myKey = targetModel[j];
          let otherKey = otherModel[myKey];

          if(myKey) {
            if(myKey === 'product_id'){
              newRow[myKey] = product_id;
            }
            if(myKey === 'userOrder_id' && userOrder_id) {
              newRow[myKey] = userOrder_id;
            }
            // if(myKey === 'platformProductId') {
            //   newRow[myKey] = platformProductId;
            // }
            // else if(myKey === 'platformData') {
            //   newRow[myKey] = row;
            //   if(addData.commentsObj && addData.commentsObj[row.article_no]) {
            //     newRow.comment = addData.commentsObj[row.article_no];
            //   }
            // }
            else if(myKey === 'platformImages') {
              if(row[otherKey] && row[otherKey].length > 0) {
                newRow[myKey] = row[otherKey];
                newRow["reviewType"] = "image";
              }
              else if(row['attach_file_urls'] && row['attach_file_urls'].length > 0) {
                newRow[myKey] = row['attach_file_urls'];
                newRow["reviewType"] = "image";
              }

            }
            else if(myKey === 'images') {
              newRow[myKey] = [];
              for(let i in otherKey) {
                if(row[otherKey[i]]) {
                  newRow[myKey].push({url: row[otherKey[i]]});
                }
              }
            }
            else if(myKey === 'movies') {
              newRow[myKey] = [];
              for(let i in otherKey) {
                if(row[otherKey[i]]) {
                  newRow[myKey].push({url: row[otherKey[i]]});
                }
              }
            }
            else if(myKey === 'isGuest') {
              newRow[myKey] = (!row['member_id']);
            }
            else if(myKey === 'isMember') {
              if(platform === 'nhnc') {
                newRow[myKey] = !!(row['member_id']);
              }
              else if(platform === 'cafe24') {

                newRow[myKey] = !!(row['member_id']);
              }
            }
            else if(addData[myKey]) {
              newRow[myKey] = addData[myKey];
            }
            else if(row[otherKey]) {

              if(myKey === 'isSecret' || myKey === 'isShow' || myKey === 'isMobile' || myKey === 'isAdult' || myKey === 'hasStock' || myKey === 'isDelete') {
                if(myKey === 'isMobile') {
                  newRow[myKey] = (row[otherKey] === 'M');
                }
                else {
                  newRow[myKey] = (row[otherKey] === 'T');
                }
              }
              else if(myKey === 'goodsPt') {
                newRow[myKey] = row[otherKey] * 20;
              }
              else if(myKey === 'contents') {
                newRow[myKey] = row[otherKey] ? row[otherKey].replace(/<\/?p>/gi, "\n") : "";
              }
              else if(myKey === 'price') {
                newRow[myKey] = row[otherKey] > 0 ?  row[otherKey] : row['price'];
              }
              else if(myKey === 'writerName') {
                newRow[myKey] = row[otherKey];
              }

              else {
                newRow[myKey] = row[otherKey];
              }
            }
            else {

              if(myKey === 'writerName') {
                newRow[myKey] = "-";
              }
              //console.log(myKey)
            }
          }
          else {
            //console.log(myKey)
          }

        }

        if(newRow.shopNo === 1) {
          newRow.product_id = platform + '_' + newRow.store_id + '_' + newRow.platformProductId;
        }
        else {
          newRow.product_id = platform + "_" + newRow.store_id + "_"  + newRow.shopNo + "_" + newRow.platformProductId;
        }
        if(newRow.platformProductId_ref) {
          newRow.platformProductId_ref += newRow.platformProductId;
          newRow._id = newRow.platformProductId_ref;
        }
        reData.push(newRow);
      }
    }

    // let myReview = ['store_id', 'platformArticleNo', 'shopNo', 'product_id', 'userOrder_id', 'platformProductId', 'platformOrderId', 'fromWrite', 'platformData', 'platformImages', 'platformUserId', 'writerName', 'writerId', 'writerEmail', 'writerPw', 'writerIp', 'subject', 'contents', 'images', 'movies', 'isSecret', 'isShow', 'isMobile',
    //   'hit', 'memoCnt', 'goodsPt', 'point', 'pointReason', 'payMileageStatus', 'payBonusMileageStatus', 'orderStatus', 'deliveryPt', 'isMember', 'isGuest', 'isAdmin', 'isDelete', 'uploadPath', 'writerAt', 'displayAt'];

    reData = reData.filter((item, i) => {;
      if (!item.platformProductId || !item.contents || !item.writerName || !item.goodsPt || !item.writerAt) {
        item.error = {};
        if (!item.platformProductId) {
          item.error.platformProductId = "상품번호를 확인해 주세요!";
        }
        if (!item.contents) {
          item.error.contents = "리뷰 내용을 확인해 주세요!";
        }
        if (!item.writerName) {
          item.error.writerName = "작성자를 확인해 주세요!";
        }
        if (!item.goodsPt) {
          item.error.goodsPt = "평점을 확인해 주세요!";
        }
        if(!item.writerAt) {
          item.error.writerAt = "작성일을 확인해 주세요!";
        }
        _this.errData.push(item);
        return false;
      }
      else {
        return true;
      }
    });

    this.isLoading = false;
    this.list = reData
    this.exImgList = _.filter(reData, function(item) {
      return item.images && item.images.length > 0;
    });
  }

  myRecombinationData = async (data, addData) => {
    let _this = this;
    console.log(data)
    data = data.filter(item => {
      if (item.error) {
        _this.errData.push(item);
        return false;
      }
      return true;
    });
    let updatedReviews = _.map(data, function(review) {
      // images_1 ~ images_5 → images 배열로 병합
      let imageList = [];
      for (let i = 1; i <= 5; i++) {
        let key = `images_${i}`;
        if (review[key]) {
          try {
            if (review[key] !=="") {
              imageList = imageList.concat( {name:review[key].split('/').pop(), url: review[key]} );
            }
          } catch (e) {}
        }
        delete review[key];
      }
      review.images = imageList;
      if(review.images.length > 0) review.reviewType = "image";

      // movies_1 ~ movies_5 → movies 배열로 병합
      let movieList = [];
      for (let i = 1; i <= 5; i++) {
        let key = `movies_${i}`;
        if (review[key]) {
          try {
            if (review[key] !=="") {
              movieList = movieList.concat( {name:review[key].split('/').pop(), url: review[key]} );
            }
          } catch (e) {}
        }
        delete review[key];
      }
      review.movies = movieList;
      if(review.movies.length > 0) review.reviewType = "movie";

      if(!review.reviewType) review.reviewType = "text";

      // 숫자형으로 변환할 키들
      ['deliveryPt', 'displayStatus', 'goodsPt', 'likeCount', 'paidMileage'].forEach(function(key) {
        if (review[key] !== undefined) {
          review[key] = parseInt(review[key], 10) || 0;
        }
      });


      // 빈 문자열, null, undefined 제거
      let cleanedReview = _.omit(review, function(value) {
        return (typeof value === 'string' && value.trim() === '') || value === null || value === undefined;
      });

      // addData 병합
      review = _.defaults({}, cleanedReview, addData);
      review.writerAt = typeof review.writerAt === "string" ? review.writerAt.trim() : review.writerAt;

      if(review.platformProductId) {
        if(review.shopNo === 1) {
          review.product_id = review.platform + "_" + review.store_id + "_" + review.platformProductId;
        }
        else {
          review.product_id = review.platform + "_" + review.store_id + "_"  + review.shopNo + "_" + review.platformProductId;
        }

      }
      if((review.writerId && review.writerId !== "") || (review.platformUserId && review.platformUserId !== "")) review.isGuest = false; review.isMember = true;
      if(review.writerAt || review.writerAt !== "") review.displayAt = moment(review.writerAt)._d;
      if(!review.writerId || review.writerId !== "") review.writerId = "nowriterid";
      if(review.deliveryPt > 0) {
        if(review.deliveryPt > 80) {
          review.compContents = review.contents + '\n 배송은 최고예요 😍';
        }
        else if(review.deliveryPt > 60){
          review.compContents = review.contents + '\n 배송은좋아요 😍';
        }
        else if(review.deliveryPt > 40){
          review.compContents = review.contents + '\n 배송은 만족해요';
        }
        else if(review.deliveryPt > 20){
          review.compContents = review.contents + '\n 배송은 아쉬워요';
        }
        else if(review.deliveryPt > 0){
          review.compContents = review.contents + '\n 배송은 별로에요';
        }
      }
      return review;
    });



    this.isLoading = false;
    this.list = updatedReviews;
    console.log(updatedReviews);
    // this.exImgList = _.filter(reData, function(item) {
    //   return item.images && item.images.length > 0;
    // });
    // console.log(this.exImgList)
  }





  toMyData = async (data) => {
    let _this = this;
    if(data.length > _this.reviewSize) {
      alert(_this.reviewSize + "개 이상의 리뷰를 한번에 등록할 수 없습니다.\n파일을 나눠서 등록 해주세요.");
      window.location.reload();
      return false;
    }
    // data = data.filter(item => {
    //   if (item.error) {
    //     _this.errData.push(item);
    //     return false;
    //   }
    //   return true;
    // });
    //
    // console.log(_this.errData)

    // store_id: this.teamUser.selStore_id,
    //     shopNo: this.teamUser.selShopNo ? this.teamUser.selShopNo : 1,
    let myReview = ['store_id', 'platformArticleNo', 'shopNo', 'product_id', 'userOrder_id', 'platformProductId', 'platformOrderId', 'fromWrite', 'platformData', 'platformImages', 'platformUserId', 'writerName', 'writerId', 'writerEmail', 'writerPw', 'writerIp', 'subject', 'contents', 'images', 'movies', 'isSecret', 'isShow', 'isMobile',
      'hit', 'memoCnt', 'goodsPt', 'point', 'pointReason', 'payMileageStatus', 'payBonusMileageStatus', 'orderStatus', 'deliveryPt', 'isMember', 'isGuest', 'isAdmin', 'isDelete', 'uploadPath', 'writerAt', 'displayAt'];

    let smartstore = {
      // userOrder_id: 'order_id',
      platformProductId: '상품번호',
      // platformUserId: 'user_id',
      // platformOrderId: 'order_id',
      // platformImages: 'image_url0',
      writerName: '등록자',
      writerId: '등록자',
      writerAt: '리뷰등록일',
      displayAt: '리뷰등록일',
      subject: '상품명',
      contents: '리뷰상세내용',
      goodsPt: '구매자평점',
      // mileage: 'reward_amount',
      images: ['포토/영상'],
      //movies: ['video_url0', 'video_url1'],
    }

    let vreview = {
      userOrder_id: 'order_id',
      platformProductId: 'product_id',
      platformUserId: 'user_id',
      platformOrderId: 'order_id',
      // platformImages: 'image_url0',
      writerName: 'author_name',
      writerId: 'user_id',
      writerAt: 'created_at',
      displayAt: 'created_at',
      subject: 'title',
      contents: 'text',
      goodsPt: 'rating',
      mileage: 'reward_amount',
      images: ['image_url0', 'image_url1', 'image_url2', 'image_url3'],
      //movies: ['video_url0', 'video_url1'],
    }



    let addData = {
      store_id: this.teamUser.selStore_id,
      shopNo: this.teamUser.selShopNo ? this.teamUser.selShopNo : 1,
      platform: this.store.platform,
      fromWrite: "file",
      displayStatus: 2,
      isSecret: false,
      isShow: true,
      isMobile: false,
      isDelete: false,
      deliveryPt: 100,
      compContents: "배송은 최고예요 😍",
      isMember: false,
      isGuest: true,
      isAdmin: true,
      writerPw: this.teamUser.emailId,
      createdAt: moment()._d,
      orderStatus: 95,
    }

    switch (this.filePlatform) {
      case 'smartstore':
        this.recombinationData(myReview, smartstore, data, addData)
        return false;
      case 'vreview':
        this.recombinationData(myReview, vreview, data, addData)
        return false;
      default:
        this.myRecombinationData(data, addData);
        return false;
    }
  };



  uploadReviewExImgs = async() => {
    let _this = this;
    if(this.exImgList && this.exImgList.length > 0) {

      let updateData = {
        store_id: this.store._id,
        shopNo: this.teamUser.selShopNo ? this.teamUser.selShopNo : 1,
        reviews: this.exImgList
      }
      // console.log('updateMassReview', updateData);
      this.props.uploadReviewExImgs(updateData, function(res) {
        _this.exImgList = res.data;

        _.each(_this.exImgList, function(item) {
          var targetItem = _.findWhere(_this.list, { exReview_id: item.exReview_id });
          if (targetItem) {
            targetItem.images = item.images;
            targetItem.platformImages = item.images;
          }
        });

      });

    }


    // // 2. filteredData의 platformImages 값 수정
    // _.each(filteredData, function(item) {
    //   item.platformImages = item.platformImages + "_modified";
    // });
    //
    // // 3. 원본 data에 filteredData 값 반영
    // _.each(data, function(item) {
    //   var updatedItem = _.findWhere(filteredData, { id: item.id });
    //   if (updatedItem) {
    //     item.platformImages = updatedItem.platformImages;
    //   }
    // });

  }


  updateMassReview = async() => {
    let _this = this;
    if(!this.isUse) {
      alert('유료회원 전용 기능입니다.');
      return false;
    }
    let updateData = {
      store_id: this.store._id,
      shopNo: this.teamUser.selShopNo ? this.teamUser.selShopNo : 1,
      reviews: this.list
    }
    // console.log('updateMassReview', updateData);
    this.props.updateMassReview(updateData, function(res) {
      if(res.data && res.data.length > 0) {
        alert(res.data.length + "개 리뷰가 등록되었습니다.");
        window.location.reload();
      }
      else {
        alert("등록 실패하였습니다. 등록한 파일 확인 또는 상담톡으로 문의 부탁드립니다.");
        window.location.reload();
      }

    });
  }

  adminCusData = async() => {
    let _this = this;

    let updateData = {
      store_id: this.store._id,
      shopNo: this.teamUser.selShopNo ? this.teamUser.selShopNo : 1,
    }
    // console.log('updateMassReview', updateData);
    this.props.adminCusData(updateData, function(res) {
      console.log(res);

    });
  }

  onChangeSelcter = async (event, targetData) => {
    const { name, value } = event.target;
    targetData[name] = value;
  }


  render() {
    let _this = this;

    function Pagination() {
      let result = [];
      let limit = _this.list.limit;
      let totalPages = _this.list.totalPages;
      let curPageNum = _this.list.page;
      let nextPage = _this.list.nextPage;
      let prevPage = _this.list.prevPage;
      let startNum = (parseInt((curPageNum-1)/10)*10) +1;
      let endNum = startNum+9 < totalPages ? startNum+9 : totalPages;

      let urlParamsArr = new URLSearchParams(window.location.search);
      urlParamsArr.delete('page');
      let urlParams = '?' + urlParamsArr.toString();

      let rendering = () => {
        for(let i = startNum; i <= endNum; i ++) {
          if(i == curPageNum) {
            result.push(<li key={i} className="on"><a href={urlParams + "&page="+i}>{i}</a></li>);
          }
          else {
            result.push(<li key={i}><a href={urlParams + "&page="+i}>{i}</a></li>);
          }
        }
        return result;
      }

      if(_this.list && _this.list.totalPages) {
        return (
            <div className="pagination">
              <ul>
                { curPageNum != 1 ? <li className="btn-page-first"><a href={urlParams + "&page=1"}><FeatherIcon icon="chevrons-left" className="nd-icon" /></a></li> : null}
                { startNum - 1 > 0 ? <li className="btn-page-prev"><a href={urlParams + "&page="+(startNum-1)}><FeatherIcon icon="chevron-left" className="nd-icon" /></a></li> : null}
                {rendering()}
                { endNum != totalPages  ? <li className="btn-page-next"><a href={urlParams + "&page="+(startNum+10)}><FeatherIcon icon="chevron-right" className="nd-icon" /></a></li> : null}
                { curPageNum != totalPages ? <li className="btn-page-last"><a href={urlParams + "&page="+totalPages}><FeatherIcon icon="chevrons-right" className="nd-icon" /></a></li> : null}
              </ul>
            </div>);
      }
      else {
        return (<></>);
      }

    }

    return (
        <div className="main-content">
          <PageTitle />

          <p><span className='warning-font'>* 해당 리뷰작성에 대한 책임은 작성자 또는 작성자가 속한 회사에 책임이 있습니다.</span></p>
          {/*<Row className="mtb-10 text-right">*/}
          {/*  <Col sm={{ size: 2, order: 2, offset: 10 }} >*/}
          {/*    <Button size="sm" onClick={event=> this.setProductSync()}><FeatherIcon size="17" icon="download" className="nd-icon" />&nbsp;&nbsp;상품정보 가져오기</Button>*/}
          {/*  </Col>*/}
          {/*</Row>*/}

          <div className="review-write-box">
            <Card className="mb-4">
              <CardHeader>* 리뷰 등록 전 필수 확인사항</CardHeader>
              <CardBody>
                <Row className="download-list">
                  <Col lg="12">
                    <p>* 엑셀 파일로 리뷰를 한번에 500개까지 등록할 수 있습니다. 아래 엑셀 양식을 다운로드 받아 사용해주세요.</p>
                    <p><a href="https://orpfrt.onreview.co.kr/downloads/onreple_review_guide.xlsx" target="_blank">샘플(가이드) 다운로드</a></p>
                    <p><a href="https://orpfrt.onreview.co.kr/downloads/onreple_review.xlsx" target="_blank">양식 다운로드</a></p>
                    <p>* 이미지 주소를 입력하실 때, 해당 이미지가 인터넷에서 계속 유지되어야 정상적으로 보입니다. 사용하시는 이미지 주소가 삭제되지 않도록 주의해 주세요. (이미지를 별도로 다운로드하여 저장/처리하지 않습니다)</p>
                    <p>* 대량 등록된 리뷰는 카페24 리뷰게시판에는 등록되지 않습니다. 카페24 리뷰게시판에도 등록을 원할 시 '리뷰/답글 > 리뷰작성' 메뉴에서 개별적으로 작성해 주세요.</p>
                  </Col>
                </Row>
              </CardBody>
            </Card>
            <Card className="mb-4">
              <CardHeader>1. 엑셀, CSV 파일 업로드

                {/*<FormSelect name="filePlatform"*/}
                {/*            value={this.filePlatform}*/}
                {/*            onChange={event => {this.onChangeSelcter(event, this)}}*/}
                {/*            className="search-type">*/}
                {/*  <option value="my">온리플</option>*/}
                {/*  <option value="smartstore">스마트스토어</option>*/}
                {/*  <option value="vreview">브이리뷰</option>*/}
                {/*</FormSelect>*/}

              </CardHeader>
              <CardBody>
                <input
                    type="file"
                    accept=".csv, .xlsx, .xls"
                    onChange={event => this.handleFileUpload(event)}
                    className="p-2 border rounded-lg"
                />
              </CardBody>
            </Card>

            {this.isUseImgCopy && process.env.NODE_ENV === "development" ? (
            <Card className="mb-4">
              <CardHeader>*. 외부 리뷰 이미지 가져오기</CardHeader>
              <CardBody>
                <div className="text-right mb-2">
                  <Button onClick={event => this.uploadReviewExImgs()}>이미지 가져오기</Button>
                </div>
                <table>
                  <colgroup>
                    <col width="15%" />
                    <col width="15%" />
                    <col width="40%" />
                    <col width="20%" />
                    <col />
                  </colgroup>
                  <thead>
                  <tr>
                    <th>상품</th>
                    <th>첨부</th>
                    <th>내용</th>
                    <th>작성자</th>
                    <th>평점</th>
                  </tr>
                  </thead>
                  <tbody>
                  {/*짱구판 쇼미더머니라는 별칭이 있는 짱구 랩배틀 시리즈 유리의 랩배틀 실력을 인정한 그 장면 기억 하시나요? 너무 귀엽네요*/}
                  {this.exImgList && this.exImgList.length > 0 ?
                      this.exImgList.map((item, i) => (
                          <tr key={i}>
                            {/*<td>{this.goodList[item.product_id].images.s_2}</td>*/}
                            <td>
                              {this.goodList[item.platformProductId] ? (
                                  <img style={{width: "150px", height:"150px"}} src={this.goodList[item.platformProductId].images.s_2} />
                              ) : null}
                              <p>{this.goodList[item.platformProductId] ? this.goodList[item.platformProductId].productName : item.platformProductId + " - 상품정보 없음"}</p>
                            </td>
                            <td>
                              {item.movies[0] ? (
                                  <video controls width="150">
                                    <source src={item.movies[0].url} type="video/webm" />
                                  </video>
                              ) : null}
                              {item.images[0] ? (
                                  <img style={{width: "150px", height:"150px"}} src={item.images[0].url} />
                              ) : null}
                            </td>
                            <td className="text-left">{item.contents}</td>
                            <td>{item.writerName}</td>
                            <td>{item.goodsPt}</td>
                          </tr>
                      ))
                      :
                      <tr>
                        <td></td>
                      </tr>
                  }
                  </tbody>
                </table>
              </CardBody>
            </Card>) : null}

            <Card className="mb-4">
              <CardHeader>2. 오류 데이터 리뷰 확인</CardHeader>
              <CardBody>
                <div className="section-box review-write-box">
                  <div className="product-list-box">
                    <div className="product-pick-list">
                      {/*<div className="pick-list-count">*/}
                      {/*  총 <span>{this.list && this.list.totalDocs ? this.list.totalDocs : 0}</span>개*/}
                      {/*</div>*/}
                    </div>
                    <table>
                      <colgroup>
                        <col width="15%" />
                        <col width="15%" />
                        <col />
                        <col width="15%" />
                        <col width="5%" />
                        <col width="15%" />
                      </colgroup>
                      <thead>
                      <tr>
                        <th>상품</th>
                        <th>첨부</th>
                        <th>내용</th>
                        <th>작성자</th>
                        <th>평점</th>
                        <th>작성일</th>
                      </tr>
                      </thead>
                      <tbody>
                      {this.errData && this.errData.length > 0 ?
                          this.errData.map((item, i) => (
                              <tr key={i}>
                                <td className={item.error && item.error.platformProductId ? 'err' : ''}>
                                  {item.error && item.error.platformProductId ? item.error.platformProductId : null}
                                  {this.goodList[item.platformProductId] ? (
                                      <img style={{width: "150px", height:"150px"}} src={this.goodList[item.platformProductId].images.s_2} />
                                  ) : null}
                                  <p>{this.goodList[item.platformProductId] ? this.goodList[item.platformProductId].productName : item.platformProductId + " - 상품정보 없음"}</p>
                                </td>
                                <td>
                                  {item.movies && item.movies[0] ? (
                                      <video controls width="150">
                                        <source src={item.movies[0].url} type="video/webm" />
                                      </video>
                                  ) : null}
                                  {item.images && item.images[0] ? (
                                      <img style={{width: "150px", height:"150px"}} src={item.images[0].url} />
                                  ) : null}
                                </td>
                                <td className={item.error && item.error.contents ? 'text-left err' : 'text-left'}>
                                  {item.error && item.error.contents ? item.error.contents : item.contents}
                                </td>
                                <td className={item.error && item.error.writerName ? 'err' : ''}>
                                  {item.error && item.error.writerName ? item.error.writerName : item.writerName}
                                </td>
                                <td className={item.error && item.error.goodsPt ? 'err' : ''}>
                                  {item.error && item.error.goodsPt ? item.error.goodsPt : item.goodsPt}
                                </td>
                                <td className={item.error && item.error.writerAt ? 'err' : ''}>
                                  {item.error && item.error.writerAt ? item.error.writerAt : item.writerAt}
                                </td>
                              </tr>
                          ))
                          :
                          <tr>
                            <td></td>
                          </tr>
                      }
                      </tbody>
                    </table>
                    {/*<div className="btn-area">*/}
                    {/*  <button className="btn-file-upload">파일 업로드</button>*/}
                    {/*</div>*/}
                    {/*<Pagination />*/}
                  </div>
                </div>
              </CardBody>
            </Card>

            <Card className="mb-4">
              <CardHeader>3. 리뷰 데이터 등록하기</CardHeader>
              <CardBody>
                <div className="section-box review-write-box">
                  <div className="text-right">
                    <Button onClick={event => this.updateMassReview()} disabled={!(this.list && this.list.length > 0)}>리뷰
                      등록하기</Button>
                  </div>
                  <div className="product-list-box">
                    <div className="product-pick-list">
                      {/*<div className="pick-list-count">*/}
                      {/*  총 <span>{this.list && this.list.totalDocs ? this.list.totalDocs : 0}</span>개*/}
                      {/*</div>*/}
                    </div>
                    <table>
                      <colgroup>
                        <col width="15%" />
                        <col width="15%" />
                        <col />
                        <col width="15%" />
                        <col width="5%" />
                        <col width="15%" />
                      </colgroup>
                      <thead>
                      <tr>
                        <th>상품</th>
                        <th>첨부</th>
                        <th>내용</th>
                        <th>작성자</th>
                        <th>평점</th>
                        <th>작성일</th>
                      </tr>
                      </thead>
                      <tbody>
                      {this.list && this.list.length > 0 ?
                          this.list.map((item, i) => (
                              <tr key={i}>
                                <td>
                                  {this.goodList[item.platformProductId] ? (
                                      <img style={{width: "150px", height:"150px"}} src={this.goodList[item.platformProductId].images.s_2} />
                                  ) : null}
                                  <p>{this.goodList[item.platformProductId] ? this.goodList[item.platformProductId].productName : item.platformProductId + " - 상품정보 없음"}</p>
                                </td>
                                <td>
                                  {item.movies && item.movies[0] ? (
                                      <video controls width="150">
                                        <source src={item.movies[0].url} type="video/webm" />
                                      </video>
                                  ) : null}
                                  {item.images && item.images[0] ? (
                                      <img style={{width: "150px", height:"150px"}} src={item.images[0].url} />
                                  ) : null}
                                </td>
                                <td className="text-left">{item.contents}</td>
                                <td>{item.writerName}</td>
                                <td>{item.goodsPt}</td>
                                <td>{item.writerAt}</td>
                              </tr>
                          ))
                          :
                          <tr>
                            <td></td>
                          </tr>
                      }
                      </tbody>
                    </table>
                    {/*<div className="btn-area">*/}
                    {/*  <button className="btn-file-upload">파일 업로드</button>*/}
                    {/*</div>*/}
                    {/*<Pagination />*/}
                  </div>
                </div>
              </CardBody>
            </Card>


          </div>
          
          <ModalLoading isLoading={this.isLoading} />
        </div>
    )
  }
}

export default ReviewMassWrite;
